<template>
  <div class="setting-popup"  v-show='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)" ref="c">
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      角色动作
    </div>
    <div class="setting-popup__content" ref="contentRef"
      v-loading="IsPreventClick"
      element-loading-text="正在生成动作..."
      element-loading-spinner="el-icon-loading"
    >
      <div>
        <!-- <gifMotionContent v-if="sprite.type === 'Gif'"></gifMotionContent> -->
        <my-lottie-motion
          :is-show="boxData.judgeBox"
          :component-height="534"
          :content-padding-style="{paddingTop: '20px'}"
          :motionGenerating="IsPreventClick"
          popup-name="motion_Lottie"
        ></my-lottie-motion>
      </div>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import popup from '../mixins/popup'
import myLottieMotion from './content/lottieMotionContent'
// import gifMotionContent from './content/gifMotionContent.vue';

export default {
  mixins: [popup],
  components: {
    myLottieMotion
  },
  data () {
    return {
      spriteType: 'motion_Lottie',
    }
  },
  computed: {
    ...mapGetters([
			'IsPreventClick',
      'SelectSprites_Msg'
    ])
  },
  watch: {
    'boxDatas.firstDatas': function () {
      if (!this.boxData.judgeBox) {
        this.$bus.emit('lottieMotion.clear');
      }
    },
  },
  mounted () {

  },
  methods: {
    stopDocument(e){      // 防止事件冒泡
      e.stopPropagation();
      e.preventDefault();
    },
  }
}
</script>

<style lang="scss" scoped>
  .setting-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 258px;
    height: 562px;
    z-index: 35;
    border-radius: 6px 6px 3px 3px;
    background: #fff;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0 0 3px 1px #d8dee9;
    color: #474261;

    &__drag-area {
      line-height: 28px;
      background: #d8dee9;
      text-align: left;
      text-indent: 14px;
    }

    &__close {
      position: absolute;
      top: 7px;
      right: 12px;
      height: 14px;
      line-height: 14px;
      width: 14px;
      cursor: pointer;
    }

    &__content {
      // padding: 14px 0;
      max-height: 562 - 28px;
      overflow: auto;

      >div {
        display: flex;
        justify-content: center;
      }
    }
  }

  .list {
    &__lottie-wrapper {
      width: 70px;
      height: 70px;
      margin: 0 auto;
    }
    >ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding-left: 20px;
      padding-right: 20px;
      >li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100px;
        height: 100px;
        cursor: pointer;
        margin-top: 20px;
        border-width: 2px;
        border-style: solid;
        border-color: transparent;
        border-radius: 8px;
        &:nth-child(1), &:nth-child(2) {
          margin-top: 0;
        }
        &:hover {
          border-style: solid;
          border-color: #5779fa;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/lottieMotion.vue